import type { EquipmentSize } from './EquipmentSize'
import type { EquipmentType } from './EquipmentType'
import type { Mode } from './Mode'

export type LanePreference = {
  id: string
  mode: Mode
  equipmentType: EquipmentType
  equipmentSize?: EquipmentSize
  subEquipmentType?: string
  extraFields?: Record<string, string>
}

export function getExtraFieldsFromPreference(
  preference: LanePreference | null | undefined
): Array<string> {
  if (!preference?.extraFields) return []

  return Object.keys(preference.extraFields).filter(key => Boolean(preference.extraFields![key]))
}
